export default "__VITE_ASSET__42885924__"